import { Injectable, OnInit, Injector } from '@angular/core';
import { HttpService } from 'app/resources/services/http.service';

@Injectable()
export class CiService {

  private quantidadeMensagensNaoLidas: number | string;
  public avisosCI: any;

  constructor(public http: HttpService) { }

  public atualizarNaoLidas() {
    const url = 'cartao/current/chamados/mensagens/naolidadas/quantidade/';
    this.http.pathRest().get(url, true)
      .subscribe(
      sucesso => {
        this.quantidadeMensagensNaoLidas = sucesso.text();
      }, erro => {});
  };

  public atualizarAvisosCI() {
    this.http.pathRest()
      .get(
      'cartao/current/avisos/', true)
      .subscribe(res => {
        this.avisosCI = res.json();
      }, erro => {});
  }

}



// WEBPACK FOOTER //
// ./src/app/resources/services/ci.service.ts